import { useCallback } from 'react';
import { useService } from '../api';
import { SubscriptionService } from './service';

export const useSubscriptionPayment = subscriptionId => {
  const service = useService(SubscriptionService);

  const requestPaymentMethodUpdate = useCallback(
    async subscriptionId =>
      await service.requestPaymentMethodUpdate(subscriptionId),
    [service],
  );

  return { requestPaymentMethodUpdate };
};
